import { useEffect } from "react";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import { ConnectInvoiceExportDialog } from "@/services/backend/connect/components/connect-invoice-export";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";
import { useHtzWorkOrderListPositionQuery } from "@/services/backend/htz/work-order/api/work-order-api";
import { WorkOrder } from "@/services/backend/htz/work-order/types/work-order";
import { useHtzPositionPrices } from "./string-builder-helpers-htz";

export function ConnectInvoiceExportDialogHtz({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <HtzInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function HtzInvoiceExport({ workOrder }: { workOrder: WorkOrder }) {
  const [editor] = useLexicalComposerContext();
  const { data: positions } = useHtzWorkOrderListPositionQuery({
    workOrder: { active: true, values: [workOrder.id] },
  });

  const title = useServiceKindTitle(GSMServiceKind.HTZ);
  const workOrderReference = useWorkOrderReference(
    workOrder.id,
    GSMServiceKind.HTZ,
  );
  const positionPrices = useHtzPositionPrices(
    positions ? positions.items : undefined,
  );
  const attachments = useAttachmentsString();

  useEffect(() => {
    editor.update(() => {
      const root = $getRoot();
      root.clear();

      const paragraphNode = $createParagraphNode();

      paragraphNode.append($createTextNode(title));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(workOrderReference));
      paragraphNode.append($createTextNode("\n"));
      paragraphNode.append(
        $createTextNode(
          `Leistungszeitpunkt: ${formatDate(workOrder.beginDate ?? "")}`,
        ),
      );
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(positionPrices));
      paragraphNode.append($createTextNode("\n\n"));
      paragraphNode.append($createTextNode(attachments));

      root.append(paragraphNode);
    });
  });

  return null;
}
